import { useState, useContext } from 'react';
import { AppContext } from '../../context/context'
import UiButton1 from '../../components/ui_button1';
import UiSpinner from '../../components/ui_spinner';

const UiPopupSidebarDeleteMarketplace = ({ closeSidebar }) => {

    const {
        neonUser,
        offCanvas,
        toDeleteMarketplace,
        setToDeleteMarketplace,
        setReloadAuthorizedMarketplaceList,
        marketplaceList,
        setToastContent,
        toastInit,
        fetchDataV2,
    } = useContext(AppContext)

    const [load, setLoad] = useState(false)

    const deleteAuthorizedMarketplace = async () => {
        setLoad(true)

        let query1 = "GET_BRAND_MARKETPLACE_BY_ID", params1 = [toDeleteMarketplace, neonUser.agency_id]
        let query2 = "GET_AUTHORIZED_MARKETPLACE_BY_ID", params2 = [toDeleteMarketplace, neonUser.agency_id]

        let [data1, data2] = await Promise.all([
            fetchDataV2(query1, params1, "/neon-query-v2"),
            fetchDataV2(query2, params2, "/neon-query-v2")
        ])

        if (!data1 || data1.length == 0) {
            setLoad(false)
            return
        }

        if (data2.map(x => x.client_profile_id).length > 0) {
            let query3 = "UPDATE_CLIENT_PROFILE_ACTIVE", params3 = [data2.map(x => x.client_profile_id)]
            await fetchDataV2(query3, params3, "/neon-market-v2")
        }

        let query4 = "INSERT_DELETED_DATA", params4 = [neonUser.user_id, JSON.stringify({ brand_marketplace: data1, authorized_marketplace: data2 })]
        await fetchDataV2(query4, params4, "/neon-query-v2")

        let query5 = "DELETE_BRAND_MARKETPLACE", params5 = [toDeleteMarketplace, neonUser.agency_id]
        let query6 = "DELETE_AUTHORIZED_MARKETPLACE", params6 = [toDeleteMarketplace, neonUser.agency_id]

        await Promise.all([
            fetchDataV2(query5, params5, "/neon-query-v2"),
            fetchDataV2(query6, params6, "/neon-query-v2")
        ])

        setToDeleteMarketplace("")
        setToastContent("Marketplace is deleted.")
        toastInit.show()
        closeSidebar()
        offCanvas.hide()
        setReloadAuthorizedMarketplaceList(true)
        setLoad(false)
        return
    }

    return (
        <div className="h-100 d-flex flex-column justify-content-between">
            <p className="poppins">Please confirm you would like to delete this marketplace. This cannot be reversed.</p>
            {load ?
                <UiSpinner />
                :
                <UiButton1 text="Delete" submit={deleteAuthorizedMarketplace} />
            }
        </div>
    )
}

export default UiPopupSidebarDeleteMarketplace